import React from 'react';
import SupplierTable from './SupplierTable';

function EnergySuppliersTable({ suppliers, remainedTotal }) {
  return (
    <SupplierTable
      title="Compensi da fee energia"
      suppliers={suppliers}
      anchorId="info-energy"
      remainedTotal={remainedTotal}
    />
  );
}

export default EnergySuppliersTable;
